import { useLocalization } from "../../hooks/useLocalization";
import { getTierIconUrl } from "../../utils/leaderboard/tier-icons";

interface OpggRankCellProps {
  tier: string | null;
  rank?: string | null;
  leaguePoints?: number | null;
  showDivision?: boolean;
  emblemSize?: number;
  muted?: boolean;
}

function capitalize(value: string): string {
  return value.charAt(0) + value.slice(1).toLowerCase();
}

export const OpggRankCell = ({
  tier,
  rank = null,
  leaguePoints = null,
  showDivision = true,
  emblemSize = 48,
  muted = false,
}: OpggRankCellProps) => {
  const { strings } = useLocalization();

  if (!tier) {
    return <span className="text-[0.88rem] text-[#8b8b9a]">{strings.LEADERBOARD.UNRANKED}</span>;
  }

  const iconUrl = getTierIconUrl(tier);
  const tierUpper = tier.toUpperCase();
  const isMasterPlus = ["MASTER", "GRANDMASTER", "CHALLENGER"].includes(tierUpper);

  const tierLabel =
    showDivision && !isMasterPlus && rank ? `${capitalize(tier)} ${rank}` : capitalize(tier);

  return (
    <div className="opgg-rank-cell flex w-full items-center gap-[0.55rem]">
      {iconUrl ? (
        <img
          className="shrink-0 object-contain"
          src={iconUrl}
          alt={strings.LEADERBOARD.RANK_EMBLEM_ALT.replace("{tier}", tierLabel)}
          width={emblemSize}
          height={emblemSize}
        />
      ) : null}
      <div className="opgg-rank-text flex min-w-0 flex-col items-start gap-[0.1rem]">
        <span className="block w-24 whitespace-nowrap text-[0.72rem] font-semibold uppercase tracking-[0.04em] text-[#8b8b9a]">
          {tierLabel}
        </span>
        <span
          className={`text-[0.92rem] font-bold tabular-nums ${muted ? "text-[#8b8b9a]" : "text-[#4fd1c5]"}`}
        >
          {leaguePoints ?? 0} {strings.LEADERBOARD.LP}
        </span>
      </div>
    </div>
  );
};
